import { render } from "./Header.vue?vue&type=template&id=6bc58a4f&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=6bc58a4f&lang=scss&scoped=true"

import exportComponent from "/Users/sarah.veysset/S/TRAVAIL/FREELANCE/OSTEO BARRY/osteo-barry/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc58a4f"]])

export default __exports__